export const isReleasedStaffEmail = (email?: string) =>
  !!email && /^jt\+deleted-[0-9a-f]{32}@gmail\.com$/i.test(email);

export const staffEmailCopy = {
  emailAlreadyUsed:
    'This email is already in use. Try a different email, or ask a MeetingMD admin for help.',
  freeEmailButton: 'Deactivate User',
  freeEmailTitle: 'Deactivate User?',
  freeEmailConfirm: (firstName: string, lastName: string) =>
    `Deactivating ${firstName} ${lastName} will free their current email address so it can be reused. Their login email will be replaced, their account will be turned off, and they will no longer appear in the staff list. Their meeting and chat history will be kept, and they will not receive an email about this. You can then add them to the new organization with their real email.`,
  freeEmailSuccess:
    'Their old email is free and their previous account is turned off. You can now add them to another organization with their real email.',
  freeEmailError:
    'We could not free this email. Try again, or contact MeetingMD support if it keeps happening.',
  deleteConfirm: (firstName: string, lastName: string) =>
    `This permanently removes ${firstName} ${lastName}. If you only need to reuse their email at another organization, choose Deactivate User instead. Permanent delete cannot be undone.`,
  deleteSuccess: 'Staff member was permanently deleted.',
  deleteError:
    'We could not permanently delete this staff member. If you need to reuse their email, choose Deactivate User instead.',
};
